export default function ServerRenderContent({ html }) {
  return <div dangerouslySetInnerHTML={{ __html: html }} />;
}
